"use client";

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en">
      <body style={{ background: "#f7f9fc", color: "#182235", fontFamily: "Inter, system-ui, sans-serif", margin: 0 }}>
        <main style={{ alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "100vh", padding: 24, textAlign: "center" }}>
          <div style={{ alignItems: "center", background: "#ffe8e3", borderRadius: 16, color: "#d76545", display: "flex", fontSize: 22, fontWeight: 900, height: 52, justifyContent: "center", width: 52 }}>!</div>
          <h1 style={{ fontSize: 28, letterSpacing: "-.035em", margin: "18px 0 8px" }}>Cognito could not start correctly</h1>
          <p style={{ color: "#718096", lineHeight: 1.6, margin: "0 0 18px", maxWidth: 520 }}>An unexpected application error prevented the interface from loading. Reload the application to try again.</p>
          <button onClick={reset} style={{ background: "#315efb", border: 0, borderRadius: 10, color: "#fff", cursor: "pointer", fontWeight: 800, padding: "11px 16px" }} type="button">Reload Cognito</button>
        </main>
      </body>
    </html>
  );
}
